export default [
  {
    name: 'project_sporting_activities',
    component_path: 'modules/templates/blocks/project/ProjectSportingActivities'
  }
]